import { AsyncPipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { DirectiveSuperclass } from '@sama/ng-core';
import { map, Observable } from 'rxjs';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';

export interface HighlightMenuConfig {
  type: 'add' | 'delete';
  action: () => void;
  onClose?: () => void;
  onCancel?: () => void;
}

const selector = 'h3-highlight-menu';
@Component({
  selector,
  templateUrl: './highlight-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatMenuModule, AsyncPipe],
})
export class HighlightMenuComponent
  extends DirectiveSuperclass
  implements AfterViewInit
{
  static readonly selector = selector;

  @Input({ required: true }) option!: HighlightMenuConfig;
  @Input({ required: true }) position!: Point2D;

  @ViewChild('menuTrigger')
  private menuTrigger!: MatMenuTrigger;

  label$: Observable<string> = this.getInput$('option').pipe(
    map((option) =>
      option.type === 'add' ? 'Add feedback' : 'Delete feedback',
    ),
  );

  private actionExecuted = false;

  ngAfterViewInit() {
    this.subscribeTo(this.menuTrigger.menuClosed, () => {
      this.option.onClose?.();
      if (!this.actionExecuted) {
        this.option.onCancel?.();
      }
    });
  }

  executeAction() {
    this.option.action();
    this.actionExecuted = true;
  }

  open() {
    this.actionExecuted = false;
    this.menuTrigger.openMenu();
  }
}
